import {all, call, put, takeEvery} from '@redux-saga/core/effects';
import {push} from 'connected-react-router';
import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult, NoData} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {SSOAccount} from 'Users/api/apiTypes';
import ssoApi from 'Users/api/ssoApi';
import {
  deleteAccount,
  getAccount,
  loadAccount,
  saveAccount,
  showError,
  SSOAccountActionType,
} from 'Users/ducks/SSO/ssoAccount';
import {getAccounts} from 'Users/ducks/SSO/ssoAccounts';
import {UserRouteConstants} from 'Users/Routes';

export function* deleteSSOAccount(action: ReturnType<typeof deleteAccount>) {
  const {username, userId, encryptedIdentifier} = action.payload;
  const result: AsyncResult<unknown> = yield call(ssoApi.deleteAccount, encryptedIdentifier, userId, username);

  if (E.isLeft(result)) {
    yield put(createSnackbar(`Unable To Delete Account: ${action.payload.username}`));
  }

  yield put(getAccounts(encryptedIdentifier, userId));
}

export function* deleteSSOAccountSaga() {
  yield takeEvery(SSOAccountActionType.DELETE, deleteSSOAccount);
}

export function* getSSOAccountApi(action: ReturnType<typeof getAccount>) {
  const {username, userId, encryptedIdentifier} = action.payload;
  const result: AsyncResult<SSOAccount> = yield call(ssoApi.getAccount, encryptedIdentifier, userId, username);

  if (E.isRight(result)) {
    yield put(loadAccount(result.right));
  } else {
    yield put(push(UserRouteConstants.SSO_ACCOUNTS));
    yield put(createSnackbar(`Unable To Load Account: ${action.payload.username}`));
  }
}

export function* getSSOAccountSaga() {
  yield takeEvery(SSOAccountActionType.GET_ACCOUNT, getSSOAccountApi);
}

export function* saveSSOAccount(action: ReturnType<typeof saveAccount>) {
  const {account, userId, isExisting, encryptedIdentifier} = action.payload;
  const result: AsyncResult<unknown> = yield ssoApi.saveSSOAccount(encryptedIdentifier, userId, account, isExisting);

  if (E.isRight(result)) {
    yield put(push(UserRouteConstants.SSO_ACCOUNTS));
  } else {
    if (result.left instanceof NoData) {
      yield put(showError(account, result.left.errorDetails));
    } else {
      yield put(showError(account, result.left.message));
    }
  }
}

export function* saveAccountSaga() {
  yield takeEvery(SSOAccountActionType.SAVE, saveSSOAccount);
}

export default function*() {
  yield all([saveAccountSaga(), getSSOAccountSaga(), deleteSSOAccountSaga()]);
}
